import(/* webpackMode: "eager" */ "/codebuild/output/src4293313936/src/apps/fanychance/src/app/error.tsx");
